var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3803 1.29077H2.69625C2.05781 1.29077 1.5 1.75015 1.5 2.38108V14.0911C1.5 14.7255 2.05781 15.2908 2.69625 15.2908H14.3769C15.0187 15.2908 15.5 14.7217 15.5 14.0911V2.38108C15.5037 1.75015 15.0187 1.29077 14.3803 1.29077ZM5.83969 12.9605H3.83406V6.72452H5.83969V12.9605ZM4.90625 5.7764H4.89187C4.25 5.7764 3.83437 5.29858 3.83437 4.70046C3.83437 4.0914 4.26094 3.62483 4.91719 3.62483C5.57344 3.62483 5.975 4.08796 5.98937 4.70046C5.98906 5.29858 5.57344 5.7764 4.90625 5.7764ZM13.1697 12.9605H11.1641V9.55077C11.1641 8.7339 10.8722 8.17577 10.1466 8.17577C9.59219 8.17577 9.26406 8.55077 9.11812 8.91608C9.06344 9.04733 9.04875 9.22608 9.04875 9.40858V12.9605H7.04312V6.72452H9.04875V7.59233C9.34062 7.17671 9.79656 6.57858 10.8575 6.57858C12.1741 6.57858 13.17 7.4464 13.17 9.31733L13.1697 12.9605Z",
    fill: "#4E944F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.9ae145d68e9ae5a81227926917ea05a0.svg";
export { ForwardRef as ReactComponent };